export const userActions = {
  CREATE: "create",
  EDIT: "edit",
} as const;

export type UserAction = (typeof userActions)[keyof typeof userActions];

/**
 * Canonical submit-handler signature shared by UserManagement (producer),
 * UsersList (passthrough) and UserActions (consumer, which `.then`s the result).
 * The form builds a plain object of field values, so the param is a record and
 * the return is always a thenable.
 */
export type UserSubmitHandler = (
  formData: Record<string, unknown>
) => Promise<unknown>;

export const userTypeEnum = {
  USER: "USER",
  SYSTEM: "SYSTEM",
} as const;

export type UserType = (typeof userTypeEnum)[keyof typeof userTypeEnum];
